import { user } from './user'
import { cart } from './cart'
import {common} from './common'
import {category} from './category'
import {goods} from './goods'
import {home} from './home'
import {order} from './order'
import {search} from './search'
import {topic} from './topic'
export const api = {
  user,
  cart,
  common,
  category,
  goods,
  home,
  order,
  search,
  topic
}



// WEBPACK FOOTER //
// ./src/service/api/index.js